/**
 * 오픈클래스 공개 목록(GET /class/open/list) — 메인 랜딩·목록 페이지 정합성
 * 메인은 넉넉히 받아 클라이언트 필터 후 일부만 노출하고, 목록도 동일 배치 크기를 쓰면
 * 같은 순서·같은 카드가 나오도록 맞출 수 있음.
 */
export const OPEN_CLASS_CLIENT_LIST_BATCH_SIZE = 48;

/** 랜딩 메인 오픈클래스 섹션 미리보기 카드 수 */
export const LANDING_OPEN_CLASS_PREVIEW_COUNT = 8;
